"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1944],{

/***/ 3875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CopyLinkButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1355);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



function CopyLinkButton(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showTooltip = ref[0], setShowTooltip = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("Copy Link"), tooltip = ref1[0], setTooltip = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showCheckmark = ref2[0], setShowCheckmark = ref2[1];
    var tooltipOriginX = props.tooltipPosition === "bottom" ? 0 : 40;
    var tooltipOriginY = props.tooltipPosition === "bottom" ? 40 : 6;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: function(e) {
                    var ref;
                    navigator.clipboard.writeText(props.link);
                    setShowTooltip(true);
                    setShowCheckmark(true);
                    setTooltip("Link Copied!");
                    setTimeout(function() {
                        setShowTooltip(false);
                    }, 1000);
                    setTimeout(function() {
                        setShowCheckmark(false);
                        setTooltip("Copy Link");
                    }, 2000);
                    (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Copy Link Button - Copy link", {
                        link: props.link
                    });
                    e.stopPropagation();
                },
                onMouseEnter: function() {
                    return setShowTooltip(true);
                },
                onMouseLeave: function() {
                    return setShowTooltip(false);
                },
                type: "button",
                className: "items-center inline-flex w-full ring-0 outline-none justify-center rounded-md border border-gray-300 bg-white bg-opacity-90 px-2 py-2 font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:col-start-1 sm:mt-0 text-xs dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700 dark:border-gray-700",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-lg mr-1 sparkle w-3",
                    children: showCheckmark ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        strokeWidth: 2,
                        stroke: "currentColor",
                        className: "w-4 h-4 text-green-600",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M4.5 12.75l6 6 9-13.5"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        className: "w-4 h-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M12.232 4.232a2.5 2.5 0 013.536 3.536l-1.225 1.224a.75.75 0 001.061 1.06l1.224-1.224a4 4 0 00-5.656-5.656l-3 3a4 4 0 00.225 5.865.75.75 0 00.977-1.138 2.5 2.5 0 01-.142-3.667l3-3z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M11.603 7.963a.75.75 0 00-.977 1.138 2.5 2.5 0 01.142 3.667l-3 3a2.5 2.5 0 01-3.536-3.536l1.225-1.224a.75.75 0 00-1.061-1.06l-1.224 1.224a4 4 0 105.656 5.656l3-3a4 4 0 00-.225-5.865z"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Transition.Root */ .u.Root, {
                style: {
                    left: tooltipOriginX,
                    top: tooltipOriginY
                },
                className: "hidden md:block absolute pointer-events-none top-8",
                show: showTooltip,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Transition.Child */ .u.Child, {
                    className: "whitespace-nowrap backdrop-blur-sm bg-black bg-opacity-70 text-white font-medium text-xs rounded-lg px-4 p-1",
                    enter: "transition-all ease-in-out duration-200",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "transition-all ease-in-out duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: tooltip
                })
            })
        ]
    });
}


/***/ }),

/***/ 1944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CreateLayout": function() { return /* binding */ CreateLayout; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ CreatePage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(5121);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-circular-progressbar/dist/styles.css
var styles = __webpack_require__(6422);
// EXTERNAL MODULE: ./services/auth.js + 44 modules
var auth = __webpack_require__(1033);
// EXTERNAL MODULE: ./components/Auth.js
var Auth = __webpack_require__(1131);
// EXTERNAL MODULE: ./components/PremiumDialog.js
var PremiumDialog = __webpack_require__(9663);
// EXTERNAL MODULE: ./components/UserContext.js
var UserContext = __webpack_require__(9277);
// EXTERNAL MODULE: ./components/Header.js + 1 modules
var Header = __webpack_require__(346);
// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(5681);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(2951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(1318);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/CrossfadeImage.js
/* eslint-disable @next/next/no-img-element */ 







var CrossfadeImage = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CrossfadeImage, Component);
    var _super = (0,_create_super/* default */.Z)(CrossfadeImage);
    function CrossfadeImage(props) {
        (0,_class_call_check/* default */.Z)(this, CrossfadeImage);
        var _this;
        _this = _super.call(this, props);
        _this.imgRef = /*#__PURE__*/ react.createRef();
        _this.state = {
            topSrc: props.src,
            bottomOpacity: 0,
            bottomSrc: props.src
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(CrossfadeImage, [
        {
            // eslint-disable-next-line react/no-deprecated
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(newProps) {
                var _this = this;
                var oldSrc = this.state.topSrc;
                var newSrc = newProps.src;
                if (newSrc !== oldSrc) {
                    // Reset the component everytime we receive new prop, to
                    // cancel out any animation that's still going on
                    this.setState({
                        bottomSrc: false,
                        topSrc: false
                    }, function() {
                        return _this.setState(// Opacity less than 1 takes precendence in stacking order
                        {
                            bottomSrc: oldSrc,
                            topSrc: newSrc,
                            bottomOpacity: 0.99
                        }, function() {
                            // One of the few times setTimeout does wonders, this is for
                            // getting fade out transition without css keyframe
                            if (_this.timeout) {
                                clearTimeout(_this.timeout);
                            }
                            if (_this.imgRef.current) {
                                _this.imgRef.current.onload = function() {
                                    _this.timeout = setTimeout(function() {
                                        return _this.setState({
                                            bottomOpacity: 0
                                        });
                                    }, 20);
                                };
                            }
                        });
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, containerClass = _props.containerClass, imgClass = _props.imgClass, duration = _props.duration, timingFunction = _props.timingFunction, delay = _props.delay, style = _props.style, alt = _props.alt;
                var _state = this.state, topSrc = _state.topSrc, bottomOpacity = _state.bottomOpacity, bottomSrc = _state.bottomSrc;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: containerClass,
                    style: (0,_object_spread/* default */.Z)({}, defaultStyle, {
                        position: "relative"
                    }),
                    children: [
                        topSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            ref: this.imgRef,
                            id: "display-image",
                            className: imgClass,
                            style: (0,_object_spread/* default */.Z)({}, defaultStyle, style, {
                                position: "absolute"
                            }),
                            src: topSrc,
                            alt: alt || "Image",
                            onLoad: function() {
                                var _props, ref;
                                return (ref = (_props = _this.props).onLoad) === null || ref === void 0 ? void 0 : ref.call(_props);
                            }
                        }),
                        bottomSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: imgClass,
                            alt: alt || "Image",
                            style: (0,_object_spread/* default */.Z)({}, defaultStyle, style, {
                                opacity: bottomOpacity,
                                transition: "opacity ".concat(duration / 1000, "s ").concat(timingFunction, " ").concat(delay / 1000, "s")
                            }),
                            src: bottomSrc,
                            onLoad: function() {
                                var _props, ref;
                                return (ref = (_props = _this.props).onLoad) === null || ref === void 0 ? void 0 : ref.call(_props);
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return CrossfadeImage;
}(react.Component);

var defaultStyle = {
    maxWidth: "100%",
    maxHeight: "100%"
};
CrossfadeImage.propTypes = {
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    duration: (prop_types_default()).number,
    timingFunction: (prop_types_default()).string,
    delay: (prop_types_default()).number,
    style: (prop_types_default()).object,
    containerClass: (prop_types_default()).string
};
CrossfadeImage.defaultProps = {
    duration: 500,
    timingFunction: "ease",
    delay: 0,
    containerClass: "CrossfadeImage"
};

// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.mjs
var dist = __webpack_require__(1571);
// EXTERNAL MODULE: ./node_modules/react-circular-progressbar/dist/index.esm.js
var index_esm = __webpack_require__(5774);
;// CONCATENATED MODULE: ./components/create/CreateProgress.js







function CreateProgress(props) {
    var ref = (0,react.useState)({
        progress: 0,
        elapsed: 0,
        remaining: 60
    }), progress = ref[0], setProgress = ref[1];
    var ref1 = (0,react.useState)(0), status = ref1[0], setStatus = ref1[1];
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setProgress(function(progress) {
                // console.log("progress", progress);
                return {
                    start: progress.start || Date.now(),
                    elapsed: progress.elapsed + 0.05,
                    remaining: Math.max(0, progress.remaining - 0.05),
                    progress: Math.min(99, Math.round((1.0 - progress.remaining / (progress.elapsed + progress.remaining)) * 100))
                };
            });
        }, 100);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if (props.status !== status && ((ref = props.status) === null || ref === void 0 ? void 0 : ref.startsWith("queued_"))) {
            setStatus(props.status);
            var queueCount = parseInt(props.status.split("queued_")[1]);
            // console.log("updating progress");
            setProgress(function(progress) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, progress), {
                    remaining: (queueCount + 1) * 20
                });
            });
        } else if (props.status !== status && props.status === "active") {
            setProgress(function(progress) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, progress), {
                    remaining: 25
                });
            });
        }
    }, [
        props.status
    ]);
    var theme = (0,dist/* useTheme */.F)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute my-16 flex items-center justify-center content-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-24 flex flex-col items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CircularProgressbar */.Ip, {
                value: progress.progress,
                text: "".concat(progress.start ? ((Date.now() - progress.start) / 1000).toFixed(1) : 0, "s"),
                styles: (0,index_esm/* buildStyles */.y3)({
                    pathColor: "#25ec7e",
                    textColor: props.hasImage ? theme === "dark" ? "#f6f6f6" : "#f6f6f6" : theme === "dark" ? "#f6f6f6" : "#333"
                }),
                className: props.hasImage ? "progress-image" : "progress-no-image"
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/create/CreateHistory.js
/* eslint-disable @next/next/no-img-element */ 



function Thumbnail(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: props.onClick,
        className: "border-2 rounded-md m-1 overflow-hidden hover:bg-white dark:hover:bg-gray-900 cursor-pointer  " + (props.selected ? "  dark:border-secondary-dark border-secondary" : "border-gray-50 dark:border-gray-900"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            width: 52,
            height: 52,
            alt: "",
            src: props.fallback ? "https://my.vectorart.ai/storage/v1/object/public/vectorart-upload/".concat(props.image) : "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/".concat(props.image, "/sm")
        })
    });
}
function CreateHistory(props) {
    var ref = (0,react.useState)([]), images = ref[0], setImages = ref[1];
    var ref1 = (0,react.useState)(null), selected = ref1[0], setSelected = ref1[1];
    (0,react.useEffect)(function() {
        setSelected(null);
        setImages([]);
        axios/* default.post */.Z.post("/api/image/history?limit=".concat(props.isMinimal ? 3 : 9)).then(function(result) {
            var ref;
            setImages((ref = result.data) === null || ref === void 0 ? void 0 : ref.history);
            if (props.latest) {
                var ref1, ref2;
                setSelected((ref2 = (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.history[0]) === null || ref2 === void 0 ? void 0 : ref2.svg);
            }
        });
    }, [
        props.latest
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-xs mb-1 font-medium px-1 dark:text-gray-400",
                children: images && images.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/my",
                    children: "My creations"
                }) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-wrap " + (props.className || ""),
                children: images === null || images === void 0 ? void 0 : images.map(function(image, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Thumbnail, {
                        selected: selected === image.svg,
                        image: image.svg,
                        fallback: image.fallback,
                        onClick: function() {
                            var ref, ref1;
                            setSelected(image.svg);
                            (ref = props.onSelect) === null || ref === void 0 ? void 0 : ref.call(props, image);
                            (ref1 = window.umami) === null || ref1 === void 0 ? void 0 : ref1.track("Create History - Select", {
                                image: image.svg
                            });
                        }
                    }, image.svg);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/ArrowDownTrayIcon.js
var ArrowDownTrayIcon = __webpack_require__(6897);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/PaintBrushIcon.js
var PaintBrushIcon = __webpack_require__(4993);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/PrinterIcon.js
var PrinterIcon = __webpack_require__(166);
// EXTERNAL MODULE: ./components/CopyLinkButton.js
var CopyLinkButton = __webpack_require__(3875);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(1355);
;// CONCATENATED MODULE: ./components/SmallDownloadButton.js




function SmallDownloadButton(props) {
    var ref = (0,react.useState)(false), showTooltip = ref[0], setShowTooltip = ref[1];
    var ref1 = (0,react.useState)("Download SVG"), tooltip = ref1[0], setTooltip = ref1[1];
    var tooltipOriginX = props.tooltipPosition === "bottom" ? 0 : 40;
    var tooltipOriginY = props.tooltipPosition === "bottom" ? 40 : 6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function(e) {
                    setShowTooltip(false);
                    props.onClick(e);
                },
                onMouseEnter: function() {
                    return setShowTooltip(true);
                },
                onMouseLeave: function() {
                    return setShowTooltip(false);
                },
                type: "button",
                className: "items-center inline-flex w-full ring-0 outline-none justify-center rounded-md border border-gray-300 bg-white bg-opacity-90 px-2 py-2 font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:col-start-1 sm:mt-0 text-xs dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700 dark:border-gray-700",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-lg mr-1 sparkle w-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownTrayIcon/* default */.Z, {
                        className: "h-4 w-4"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
                style: {
                    left: tooltipOriginX,
                    top: tooltipOriginY
                },
                className: "hidden md:block absolute pointer-events-none top-8",
                show: showTooltip,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    className: "whitespace-nowrap backdrop-blur-sm bg-black bg-opacity-70 text-white font-medium text-xs rounded-lg px-4 p-1",
                    enter: "transition-all ease-in-out duration-200",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "transition-all ease-in-out duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: tooltip
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ClipboardIcon.js
var ClipboardIcon = __webpack_require__(3306);
;// CONCATENATED MODULE: ./components/CopySvgButton.js




function CopySvgButton(props) {
    var ref = (0,react.useState)(false), showTooltip = ref[0], setShowTooltip = ref[1];
    var ref1 = (0,react.useState)("Copy SVG"), tooltip = ref1[0], setTooltip = ref1[1];
    var ref2 = (0,react.useState)(false), showCheckmark = ref2[0], setShowCheckmark = ref2[1];
    var tooltipOriginX = props.tooltipPosition === "bottom" ? 0 : 40;
    var tooltipOriginY = props.tooltipPosition === "bottom" ? 40 : 6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function(e) {
                    var ref;
                    (ref = props.getContent) === null || ref === void 0 ? void 0 : ref.call(props).then(function(text) {
                        var ref;
                        if (!text) {
                            return;
                        }
                        navigator.clipboard.writeText(text);
                        setShowTooltip(true);
                        setShowCheckmark(true);
                        setTooltip("SVG Copied!");
                        setTimeout(function() {
                            setShowTooltip(false);
                        }, 1000);
                        setTimeout(function() {
                            setShowCheckmark(false);
                            setTooltip("Copy SVG");
                        }, 2000);
                        (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Copy SVG Button - Copy SVG", {});
                    });
                    e.stopPropagation();
                },
                onMouseEnter: function() {
                    return setShowTooltip(true);
                },
                onMouseLeave: function() {
                    return setShowTooltip(false);
                },
                type: "button",
                className: "items-center inline-flex w-full ring-0 outline-none justify-center rounded-md border border-gray-300 bg-white bg-opacity-90 px-2 py-2 font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:col-start-1 sm:mt-0 text-xs dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700 dark:border-gray-700",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-lg mr-1 sparkle w-3",
                    children: showCheckmark ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        strokeWidth: 2,
                        stroke: "currentColor",
                        className: "w-4 h-4 text-green-600",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M4.5 12.75l6 6 9-13.5"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipboardIcon/* default */.Z, {
                        className: "w-4 h-4"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
                style: {
                    left: tooltipOriginX,
                    top: tooltipOriginY
                },
                className: "hidden md:block absolute pointer-events-none top-8",
                show: showTooltip,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    className: "whitespace-nowrap backdrop-blur-sm bg-black bg-opacity-70 text-white font-medium text-xs rounded-lg px-4 p-1",
                    enter: "transition-all ease-in-out duration-200",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "transition-all ease-in-out duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: tooltip
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-to-print/lib/index.js
var lib = __webpack_require__(7116);
;// CONCATENATED MODULE: ./components/create/CreateResult.js
/* eslint-disable @next/next/no-img-element */ 















function CreateResult(props) {
    var ref, ref1;
    var svgUrl = props.svgUrl, isCreating = props.isCreating, isFallback = props.isFallback, error = props.error, status = props.status, loadingTime = props.loadingTime, identifier = props.identifier, onSelectItem = props.onSelectItem, showDownloadPng = props.showDownloadPng, showPrint = props.showPrint;
    var ref2 = (0,react.useState)(null), selectedItem = ref2[0], setSelectedItem = ref2[1];
    var ref3 = (0,react.useState)(false), hasImage = ref3[0], setHasImage = ref3[1];
    var ref4 = (0,react.useState)(svgUrl), imgSrc = ref4[0], setImgSrc = ref4[1];
    var downloadSVG = function() {
        if (!imgSrc) {
            return;
        }
        (0,utils/* downloadImage */.G)(imgSrc, "svg");
    };
    var downloadPNG = function() {
        if (!selectedItem && !identifier) {
            return;
        }
        var url = "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/".concat((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.identifier) || identifier, "/orig");
        ;
        (0,utils/* downloadImage */.G)(url, "png");
    };
    var printImage = function() {
        if (!imgSrc) {
            return;
        }
        reactToPrintFn();
    };
    (0,react.useEffect)(function() {
        var result = null;
        if (svgUrl && !isCreating) {
            result = svgUrl;
        } else if (status === "init") {
            setImgSrc(null);
            return;
        } else if (!svgUrl && identifier) {
            var blurKey = "blurmax";
            if (loadingTime > 40) {
                blurKey = "blur10";
            } else if (loadingTime > 26) {
                blurKey = "blur15";
            } else if (loadingTime > 20) {
                blurKey = "blur20";
            } else if (loadingTime > 16) {
                blurKey = "blur25";
            } else if (loadingTime > 12) {
                blurKey = "blur50";
            } else if (loadingTime > 8) {
                blurKey = "blur75";
            } else if (loadingTime > 4) {
                blurKey = "blur";
            }
            result = "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/".concat(identifier, "/").concat(blurKey);
        }
        setImgSrc(result);
    }, [
        isCreating,
        svgUrl,
        isFallback,
        loadingTime,
        identifier
    ]);
    (0,react.useEffect)(function() {
        if (props.isCreating) {
            setSelectedItem(null);
            setHasImage(false);
        }
    }, [
        props.isCreating
    ]);
    var contentRef = (0,react.useRef)(null);
    var reactToPrintFn = (0,lib.useReactToPrint)({
        contentRef: contentRef
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex-1 flex items-center justify-center overflow-hidden max-auto mt-8 sm:h-full relative",
        children: [
            !isCreating && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden sm:block w-48 mr-3"
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center self-center items-center my-8 text-red-800",
                children: error
            }),
            !error && imgSrc && props.previewView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center flex justify-center h-full flex-1 sm:flex-none sm:w-[512px] lg:mx-[85.5px]",
                children: isCreating ? null : props.previewView
            }),
            !error && imgSrc && !props.previewView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center flex justify-center h-full flex-1 sm:flex-none sm:w-[512px] lg:mx-[85.5px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: contentRef,
                    className: "group relative block w-full max-h-full print-wrapper ",
                    onClick: function(e) {
                        if (imgSrc && !props.isCreating) {
                            var ref;
                            downloadSVG();
                            e.preventDefault();
                            e.stopPropagation();
                            (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Result - Download 1", {});
                        }
                    },
                    children: [
                        (imgSrc === null || imgSrc === void 0 ? void 0 : imgSrc.includes("my.vectorart.ai")) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "rounded-md overflow-hidden h-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "rounded-md height-auto max-h-full w-full",
                                src: imgSrc
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossfadeImage, {
                            containerClass: "rounded-md overflow-hidden h-full",
                            imgClass: "rounded-md height-auto max-h-full w-full",
                            src: imgSrc,
                            alt: prompt,
                            onLoad: function() {
                                return setHasImage(true);
                            },
                            duration: svgUrl || selectedItem && !isCreating ? 300 : 4000
                        }, identifier),
                        (svgUrl || selectedItem) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "absolute top-4 left-4 flex invisible group-hover:visible ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative mr-3 cursor-pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallDownloadButton, {
                                        tooltipPosition: "bottom",
                                        onClick: function(e) {
                                            if (imgSrc) {
                                                var ref;
                                                downloadSVG();
                                                e.preventDefault();
                                                e.stopPropagation();
                                                (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Result - Download 2", {});
                                            }
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative mr-3 cursor-pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopySvgButton, {
                                        tooltipPosition: "bottom",
                                        getContent: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                            var url, response, text;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        url = imgSrc || svgUrl;
                                                        if (!url) {
                                                            return [
                                                                2,
                                                                false
                                                            ];
                                                        }
                                                        return [
                                                            4,
                                                            fetch(url)
                                                        ];
                                                    case 1:
                                                        response = _state.sent();
                                                        return [
                                                            4,
                                                            response.text()
                                                        ];
                                                    case 2:
                                                        text = _state.sent();
                                                        return [
                                                            2,
                                                            text
                                                        ];
                                                }
                                            });
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative mr-3 cursor-pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyLinkButton/* default */.Z, {
                                        tooltipPosition: "bottom",
                                        link: selectedItem ? "https://vectorart.ai/".concat(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.svg) : "https://vectorart.ai/".concat(svgUrl.includes("my.vectorart.ai") ? svgUrl.split("/").slice(-1)[0] : svgUrl.split("/").slice(-2)[0])
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            isCreating && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateProgress, {
                status: status,
                hasImage: hasImage
            }),
            !isCreating && !svgUrl && !error && !selectedItem && (props.initialComponent ? props.initialComponent : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex sm:mx-32 flex-col items-center justify-end sm:h-full xl:w-[427px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "Enter your prompt",
                            src: "/sparkle.svg",
                            className: "w-52 opacity-10 dark:opacity-40"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-4xl font-bold text-gray-700 dark:text-gray-100 mb-2 mt-8",
                                children: "Start Creating"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-gray-500 dark:text-gray-400 mb-8",
                                children: "Enter your prompt to get started"
                            })
                        ]
                    })
                ]
            })),
            !isCreating && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden sm:flex flex-col w-48 self-start ml-3 h-full",
                children: [
                    props.dropzone && imgSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1",
                        children: props.dropzone
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateHistory, {
                        isMinimal: props.isMinimal,
                        latest: isCreating ? null : svgUrl,
                        onSelect: function(item) {
                            var svgUrl = item.fallback ? "https://my.vectorart.ai/storage/v1/object/public/vectorart-upload/".concat(item.svg) : "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/".concat(item.svg, "/sm");
                            setImgSrc(svgUrl);
                            setSelectedItem(item);
                            onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem(item);
                        }
                    }),
                    !props.isMinimal && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-3 ml-1 flex-1 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pb-6 sm:pt-0 sm:pb-2 text-gray-700 font-light text-sm hidden lg:block dark:text-gray-400",
                                children: (0,lodash.capitalize)(selectedItem === null || selectedItem === void 0 ? void 0 : (ref = selectedItem.prompt) === null || ref === void 0 ? void 0 : ref.slice(0, 110)) + ((selectedItem === null || selectedItem === void 0 ? void 0 : (ref1 = selectedItem.prompt) === null || ref1 === void 0 ? void 0 : ref1.length) > 110 ? "..." : "")
                            }),
                            (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.mode) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inline-block px-2 py-0.5 text-gray-700 text-xs rounded-lg bg-gray-300 dark:bg-gray-700 dark:text-gray-300",
                                children: (0,lodash.startCase)(selectedItem.mode)
                            })
                        ]
                    }),
                    imgSrc && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "align-bottom mt-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "focus:outline-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/edit/".concat((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.svg) || (svgUrl === null || svgUrl === void 0 ? void 0 : svgUrl.split("/").slice(-2)[0])),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "focus:outline-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "flx items-center text-left border border-gray-300 dark:border-gray-700 bg-white disabled:bg-gray-500 inline-flex w-full justify-center rounded-md px-4 py-2 font-medium text-black focus:outline-none sm:col-start-2 text-xs md:text-sm hover:bg-gray-100 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaintBrushIcon/* default */.Z, {
                                                className: "w-3 h-3 mr-4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex-1",
                                                children: "Edit image"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: function(e) {
                                        if (imgSrc) {
                                            var ref;
                                            downloadSVG();
                                            e.preventDefault();
                                            (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Result - Download 3", {});
                                        }
                                    },
                                    type: "button",
                                    className: "mt-3 text-left items-center bg-white disabled:bg-gray-500 inline-flex w-full shadow-sm justify-center rounded-md border border-gray-300 dark:border-gray-700 px-4 py-2 font-medium text-black focus:outline-none sm:col-start-2 text-xs md:text-sm dark:bg-gray-800 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownTrayIcon/* default */.Z, {
                                            className: "h-4 w-4 mr-3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-1",
                                            children: "Download SVG"
                                        })
                                    ]
                                })
                            }),
                            showDownloadPng && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: function(e) {
                                        if (imgSrc) {
                                            var ref;
                                            downloadPNG();
                                            e.preventDefault();
                                            (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Result - Download PNG", {});
                                        }
                                    },
                                    type: "button",
                                    className: "mt-3 text-left items-center bg-white disabled:bg-gray-500 inline-flex w-full shadow-sm justify-center rounded-md border border-gray-300 dark:border-gray-700 px-4 py-2 font-medium text-black focus:outline-none sm:col-start-2 text-xs md:text-sm dark:bg-gray-800 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownTrayIcon/* default */.Z, {
                                            className: "h-4 w-4 mr-3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-1",
                                            children: "Download PNG"
                                        })
                                    ]
                                })
                            }),
                            showPrint && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: function(e) {
                                        if (imgSrc) {
                                            var ref;
                                            printImage();
                                            e.preventDefault();
                                            (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Result - Print Image", {});
                                        }
                                    },
                                    type: "button",
                                    className: "mt-3 text-left items-center bg-white disabled:bg-gray-500 inline-flex w-full shadow-sm justify-center rounded-md border border-gray-300 dark:border-gray-700 px-4 py-2 font-medium text-black focus:outline-none sm:col-start-2 text-xs md:text-sm dark:bg-gray-800 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PrinterIcon/* default */.Z, {
                                            className: "h-4 w-4 mr-3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-1",
                                            children: "Print Image"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-6 text-xs mb-1 text-gray-500 hidden lg:block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "VectorArt.ai License"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "Commercial use permitted with a",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/pricing",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "cursor-pointer",
                                            children: "paid subscription"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 11 modules
var dialog = __webpack_require__(5408);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 3 modules
var listbox = __webpack_require__(9262);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/RectangleStackIcon.js
var RectangleStackIcon = __webpack_require__(9714);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/ChevronUpDownIcon.js
var ChevronUpDownIcon = __webpack_require__(6032);
;// CONCATENATED MODULE: ./components/create/CreateModes.js

var modes = [
    {
        name: "Simple",
        image: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                viewBox: "0 0 90.00013 80.960342",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "m.12781732 63.148c-1.0873-16.95 4.92119998-30.276 11.98099968-38.025 7.061-7.748 16.575-11.446 30.719-14.004 14.144-2.559 34.331 2.049 47.122-11.119 2.023 81.879-57.465 93.65-86.5959997 70.468 10.1519997-12.225 21.5169997-20.905 37.0709997-26.579 11.169-4.075 21.273-6.103 31.66-18.084-15.198 10.33-27.431 11.088-36.471 13.939-13.429 4.236-24.045 9.926-35.48599968 23.404z",
                    fillRule: "evenodd"
                })
            }, "simple"), 
        ]
    },
    {
        name: "Logo",
        image: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                viewBox: "0 0 90 90",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    clipRule: "evenodd",
                    d: "m76.8198 13.1802c8.4391 8.4391 13.1802 17.8851 13.1802 29.8198h-30.1322c-.9778-7.3387-7.2616-13-14.8678-13s-13.89 5.6613-14.8678 13h-30.1322c.00001-11.9347 4.74107-21.3807 13.1802-29.8198 8.4391-8.43914 19.8851-13.1802 31.8198-13.1802s23.3807 4.74106 31.8198 13.1802zm-31.8198 46.8198c-7.6062 0-13.89-5.6613-14.8678-13h-30.1322c0 11.9347 4.74106 21.3807 13.1802 29.8198 8.4391 8.4391 19.8851 13.1802 31.8198 13.1802s23.3807-4.7411 31.8198-13.1802 13.1802-17.8851 13.1802-29.8198h-30.1322c-.9778 7.3387-7.2616 13-14.8678 13zm0-4c6.0751 0 11-4.9249 11-11s-4.9249-11-11-11-11 4.9249-11 11 4.9249 11 11 11z",
                    fillRule: "evenodd"
                })
            }, "logo"), 
        ]
    },
    {
        name: "Icon",
        image: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                viewBox: "0 0 80 76.208847",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "m50.000001 974.36218c3.185174 0 9.3314-11.02653 12.360681-10.04226 3.029281.98428 1.520446 13.51759 4.097306 15.38979s14.030495-3.4358 15.902693-.85894c1.872199 2.57686-6.715371 11.82966-5.731098 14.85894s13.370417 5.4673 13.370417 8.65249c0 3.1852-12.386145 5.6232-13.370418 8.6525-.984273 3.0292 7.603295 12.282 5.731096 14.8589-1.872198 2.5769-13.325831-2.7311-15.902692-.8589-2.57686 1.8722-1.068027 14.4055-4.097309 15.3897-3.02928.9843-9.175503-10.0422-12.360678-10.0422-3.185174 0-9.3314 11.0265-12.360681 10.0422-3.029281-.9842-1.520446-13.5175-4.097306-15.3897s-14.030495 3.4358-15.902693.8589c-1.872199-2.5769 6.715371-11.8297 5.731098-14.8589-.984273-3.0293-13.3704171-5.4673-13.370417-8.6525 0-3.18519 12.386145-5.62321 13.370418-8.65249s-7.603295-12.28208-5.731096-14.85894c1.872198-2.57686 13.325831 2.73113 15.902692.85894 2.57686-1.8722 1.068027-14.40552 4.097309-15.38979 3.02928-.98427 9.175503 10.04226 12.360678 10.04226z",
                    transform: "translate(-10 -964.25774)"
                })
            }, "icon"), 
        ]
    },
    {
        name: "Artistic",
        image: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                viewBox: "0 0 86.239883 73.107674",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "m84.242386 27.916677a43.779 43.779 0 0 0 -2.03-3.934l-9.572 26.006a8.972 8.972 0 0 1 -1.57 2.663c10.521-.984 18.2-12.033 14-22.716-.258-.686-.534-1.353-.828-2.019z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "m29.293386 4.4896766a44.079 44.079 0 0 0 -26.1510003 57.8700004c.059.118.1.235.157.353 5.038 12.311 22.0000003 13.938 29.3660003 2.862a31.341 31.341 0 0 1 14.507-11.782c.188-.074.379-.13.567-.2a11.607 11.607 0 0 1 7.236-6.474 9.117 9.117 0 0 1 .846-4.094l14.816-32.076a44.165 44.165 0 0 0 -41.344-6.4590004zm-11.493 48.9310004a7.5 7.5 0 1 1 7.5-7.5 7.5 7.5 0 0 1 -7.5 7.5zm9.375-21.563a7.5 7.5 0 1 1 7.5-7.5 7.5 7.5 0 0 1 -7.5 7.5zm22.5-6.562a7.5 7.5 0 1 1 7.5-7.5 7.5 7.5 0 0 1 -7.5 7.5z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "m83.384386.26667659a3.484 3.484 0 0 0 -4.5 1.75700001l-19.658 42.5730004a5.359 5.359 0 0 0 1 5.962 7.92 7.92 0 0 0 -9.114 4.67c-3.037 7.331 1.766 10.548-1.27 17.879 0 0 11.378-.809 15.933-11.806a7.909 7.909 0 0 0 -2.344-9.162 5.345 5.345 0 0 0 5.694-3.445l16.194-44.0120004a3.483 3.483 0 0 0 -1.935-4.41600001z"
                    })
                ]
            }, "artistic"), 
        ]
    },
    {
        name: "Anime",
        image: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                enableBackground: "new 0 0 100 100",
                viewBox: "0 0 100 100",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "m50 0c-27.57 0-50 22.43-50 50s22.43 50 50 50 50-22.43 50-50-22.43-50-50-50zm0 90.644c-22.411 0-40.644-18.233-40.644-40.644s18.233-40.644 40.644-40.644 40.644 18.233 40.644 40.644-18.233 40.644-40.644 40.644z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "m50 15.578c-19.01 0-34.421 15.412-34.421 34.422 0 19.011 15.411 34.422 34.421 34.422 19.012 0 34.422-15.411 34.422-34.422 0-19.01-15.411-34.422-34.422-34.422zm15.095 55.674-15.019-8.283-14.92 8.279 2.696-16.812-12.027-11.874 16.815-2.345 7.435-15.268 7.534 15.318 16.565 2.288-12.025 11.881z"
                    })
                ]
            }, "comic-book"), 
        ]
    },
    {
        name: "Line Art",
        image: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                enableBackground: "new 0 0 50 50",
                viewBox: "0 0 49.666 49.667999",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "m24.833 0c-13.693 0-24.833 11.14-24.833 24.833 0 13.694 11.14 24.835 24.833 24.835s24.833-11.141 24.833-24.835c0-13.693-11.14-24.833-24.833-24.833zm0 42.668c-9.833 0-17.833-8.001-17.833-17.835 0-9.833 8-17.833 17.833-17.833s17.833 8 17.833 17.833c0 9.834-8 17.835-17.833 17.835z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "m24.833 11.244c-7.494 0-13.59 6.096-13.59 13.59s6.096 13.59 13.59 13.59c7.493 0 13.59-6.097 13.59-13.59s-6.097-13.59-13.59-13.59zm0 20.18c-3.634 0-6.59-2.956-6.59-6.59s2.957-6.59 6.59-6.59 6.59 2.956 6.59 6.59-2.956 6.59-6.59 6.59z"
                    })
                ]
            }, "line-art"), 
        ]
    },
    {
        name: "Low Poly",
        image: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                viewBox: "0 0 56 56",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    transform: "translate(-4 -4)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "m59 60h-54l27-16z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "m60 58-27-16v-38z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "m31 4v38l-27 16z"
                        })
                    ]
                })
            }, "low-poly"), 
        ]
    }, 
];
/* harmony default export */ var CreateModes = (modes);

;// CONCATENATED MODULE: ./components/create/CreateModeButton.js
/* eslint-disable @next/next/no-img-element */ 








var collections = [
    {
        name: "Flat Circles",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4a8ba709f30ecf30dd39/xxs"
    },
    {
        name: "Olden Vibes",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/46ea875703f94a097712/xxs"
    },
    {
        name: "Soft Blobs",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4b1abd7544706da13974/xxs"
    },
    {
        name: "Raw Forms",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4699823fa952ca211672/xxs"
    },
    {
        name: "Playful Strokes",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4896b02e17ea42c5f189/xxs"
    },
    {
        name: "Warm Endeavors",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/438fb0e059a12d2676b9/xxs"
    },
    {
        name: "Cyan Essence",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4049b05a36a545a7540f/xxs"
    },
    {
        name: "Stochastic Splash",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4d0daab197533da468c8/xxs"
    },
    {
        name: "Sharp Teal",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4b21a4f419bac75dc110/xxs"
    },
    {
        name: "Nature's Tales",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/W5SgTAApH8pQ6mxnbt2iPu9jx0WL8rmc/xxs"
    },
    {
        name: "Urban Observations",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/2wBE53qhwIVZAZ3Ob_XbnJ1-E5olCFIP/xxs"
    },
    {
        name: "Fantasy Visions",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/BMBtuwQD0AugOEEYeihGM0qo9s4mxCk2/xxs"
    },
    {
        name: "Corporate Memphis",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/RqgrSkpqPpqN9kPqMdXc-_EmnhRZLbs5/xxs"
    },
    {
        name: "Dotted Dimensions",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/47NYe2HAi-oYqJRtIVtoDURwQ400tRlF/xxs"
    },
    {
        name: "Timeless Tales",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/g3MQ9wlPKTGwQLKAgF8DeX2ZGaEF93GR/xxs"
    },
    {
        name: "Scribbled Stories",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/BE8v7P6NxPFkU6xvMejjvBrkCsIJqBE_/xxs"
    },
    {
        name: "Liquid Elegance",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/7Hin0C-ImZx4jSehmkl_R2pN2ZFMGELW/xxs"
    },
    {
        name: "Vivid Folklore",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/0DVuHQOVfn9X3hvhJeQ4qqYUHtUdrXRe/xxs"
    },
    {
        name: "Enchanted Sketches",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/YRwV6eTT9wNI6ajP1T8qs5WbdvIVXZIE/xxs"
    },
    {
        name: "Modern Musings",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/DNOMjcG0nc4TAcCCJGe4Oze8YEsEEbWu/xxs"
    },
    {
        name: "Wild Imaginations",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/KrnJia3bsRqRItK7ENqY_VWaPw55Ljwl/xxs"
    },
    {
        name: "Witty Watercolors",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/_qOBCY_gVTxF6so5HP5PTYFZAPNzziBE/xxs"
    },
    {
        name: "Fjord Fantasies",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/7s2Rsy5jbEaUKngo6MHu8SAePkDq8gcv/xxs"
    },
    {
        name: "Dark Dreamscapes",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/3Fn1UXomVpzyIOaireOSblPOUtCFb4LG/xxs"
    },
    {
        name: "Vibrant Collisions",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/bNmozNipMHUT5MOA43JqdfyVgQydW9M1/xxs"
    },
    {
        name: "Cubist Kaleidoscope",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/nnEwqsfTsXnZCgB6QYqm-7jnH8e06nP3/xxs"
    },
    {
        name: "Environment Concepts",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/DvstafsOVoFEd4YZSNRl1Olk1pv3mB_i/xxs"
    },
    {
        name: "Melancholic Magic",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/UjZ5TmFy_j6HL6edtwxGSdYVshzsgxmV/xxs"
    },
    {
        name: "Retro Reveries",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/hZlM3nezyETMZUdwrHEDvkWENTCYQKEO/xxs"
    },
    {
        name: "Serene Sceneries",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/8omdpLtzopVFBXHm1AZcoOd3dlb2P9gb/xxs"
    },
    {
        name: "Pastel Portals",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/OJOmqM7xwA9Gr2niDJopX4m2nB79iWcF/xxs"
    },
    {
        name: "Radiant Rhythms",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/J_-C092CBCbWUEmsRTvzaAI2NJ1VFaPY/xxs"
    },
    {
        name: "Graphic Grit",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/z_6aWDzXrzehzFd29D4HMP7uM6q4l7jy/xxs"
    },
    {
        name: "Whimsical Wonders",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/-i-XEiWjYUodJEl1I1x0xxDs-289QxYN/xxs"
    },
    {
        name: "Geometric Grace",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/XJydbycU-FD1TUfYQojDaQNE3ndNUK2E/xxs"
    },
    {
        name: "Abstract Aria",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4ZmoHvQU067i37TLK7xM5zQg-dhq6E6r/xxs"
    }, 
];
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function ModeItem(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: props.selected ? props.selectedRef : null,
        onClick: function() {
            return props.onSelect();
        },
        className: classNames("group shadow rounded-lg relative flex items-center overflow-hidden flex-col cursor-pointer border dark:border-gray-600 dark:hover:border-gray-500 m-2 w-32 sm:w-36 h-32 text-xs text-center hover:border-secondary transition-all duration-200", props.selected ? "bg-secondary-extralight border-secondary-dark dark:bg-gray-800 dark:border-secondary dark:hover:border-secondary" : "dark:bg-gray-600"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute h-24 overflow-hidden flex items-center justify-center w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-8 w-8 dark:fill-gray-100 fill-back text-black dark:text-gray-300 transition-transform duration-200 group-hover:scale-110",
                    children: props.image
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute bottom-0 my-2 text-gray-800 dark:text-gray-100 font-semibold",
                children: props.name
            })
        ]
    });
}
function CollectionSelectorItem(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: props.selected ? props.selectedRef : null,
        onClick: function() {
            return props.onSelect();
        },
        className: classNames("group shadow relative flex items-center overflow-hidden flex-col cursor-pointer border dark:border-gray-600 dark:hover:border-gray-500 rounded-lg m-2 w-32 sm:w-36 h-32 text-xs text-center hover:border-secondary transition-all duration-200", props.selected ? "bg-secondary-extralight border-secondary-dark dark:bg-gray-800 dark:border-secondary dark:hover:border-secondary" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute h-24 overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: props.image,
                    alt: props.name,
                    className: "-mt-2 w-36 h-36 transition-transform duration-200 group-hover:scale-110"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute bottom-0 my-2 text-gray-800 dark:text-gray-100 ",
                children: props.name
            })
        ]
    });
}
function CollectionSelector(props) {
    var scrollContainerRef = (0,react.useRef)(null);
    var selectedItemRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), userHasInteracted = ref[0], setUserHasInteracted = ref[1];
    // Create combined options with type information
    var allOptions = (0,_to_consumable_array/* default */.Z)(CreateModes.map(function(mode) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mode), {
            type: "mode"
        });
    })).concat((0,_to_consumable_array/* default */.Z)(collections.map(function(collection) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collection), {
            type: "collection"
        });
    })));
    var ref1 = (0,react.useState)(function() {
        if (props.initialCollection) {
            return allOptions.find(function(option) {
                return option.type === "collection" && option.name === props.initialCollection;
            }) || allOptions[0];
        }
        if (props.initialMode) {
            return allOptions.find(function(option) {
                return option.type === "mode" && option.name === props.initialMode;
            }) || allOptions[0];
        }
        return allOptions[0];
    }), selected = ref1[0], setSelected = ref1[1];
    ;
    // Reset user interaction flag when dialog opens
    (0,react.useEffect)(function() {
        if (props.open) {
            setUserHasInteracted(false);
        }
    }, [
        props.open
    ]);
    // Scroll to selected item only when dialog first opens, not after user clicks
    (0,react.useEffect)(function() {
        if (props.open && !userHasInteracted && selectedItemRef.current && scrollContainerRef.current) {
            var container = scrollContainerRef.current;
            var selectedElement = selectedItemRef.current;
            var containerRect = container.getBoundingClientRect();
            var elementRect = selectedElement.getBoundingClientRect();
            var isVisible = elementRect.top >= containerRect.top && elementRect.bottom <= containerRect.bottom;
            if (!isVisible) {
                selectedElement.scrollIntoView({
                    behavior: "instant",
                    block: "start"
                });
            }
        }
    }, [
        props.open,
        selected,
        userHasInteracted
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: props.open,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-10",
            onClose: props.setOpen,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 dark:bg-gray-950 dark:bg-opacity-75 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 z-10 w-screen sm:my-16",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex min-h-full items-end h-full justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                                className: "relative transform h-full flex flex-col overflow-hidden rounded-lg bg-white px-4 pb-4 pt-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[45rem] sm:p-6 sm:pt-4 dark:bg-gray-700",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-lg font-medium text-gray-900 dark:text-gray-100",
                                            children: "Select Style"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        ref: scrollContainerRef,
                                        className: "w-full h-full overflow-x-hidden overflow-y-auto flex-1 mb-4",
                                        style: {
                                            scrollbarWidth: "thin",
                                            scrollbarColor: "rgb(156 163 175) transparent",
                                            WebkitScrollbarWidth: "thin"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex flex-wrap justify-center sm:justify-start",
                                                    children: CreateModes.map(function(mode) {
                                                        /*#__PURE__*/ return (0,react.createElement)(ModeItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mode), {
                                                            key: mode.name,
                                                            selected: (selected === null || selected === void 0 ? void 0 : selected.name) === mode.name,
                                                            selectedRef: (selected === null || selected === void 0 ? void 0 : selected.name) === mode.name ? selectedItemRef : null,
                                                            onSelect: function() {
                                                                setUserHasInteracted(true);
                                                                setSelected((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mode), {
                                                                    type: "mode"
                                                                }));
                                                            }
                                                        }));
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex flex-wrap justify-center sm:justify-start",
                                                    children: collections.map(function(collection) {
                                                        /*#__PURE__*/ return (0,react.createElement)(CollectionSelectorItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collection), {
                                                            key: collection.name,
                                                            selected: (selected === null || selected === void 0 ? void 0 : selected.type) === "collection" && (selected === null || selected === void 0 ? void 0 : selected.name) === collection.name,
                                                            selectedRef: (selected === null || selected === void 0 ? void 0 : selected.type) === "collection" && (selected === null || selected === void 0 ? void 0 : selected.name) === collection.name ? selectedItemRef : null,
                                                            onSelect: function() {
                                                                setUserHasInteracted(true);
                                                                setSelected((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collection), {
                                                                    type: "collection"
                                                                }));
                                                            }
                                                        }));
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-4 sm:mt-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "inline-flex w-full justify-center rounded-md bg-secondary-dark px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-secondary-darkest focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                                            onClick: function() {
                                                var ref;
                                                props.setOpen(false);
                                                props.setSelected(selected);
                                                (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Mode Button - Select style", {
                                                    type: selected.type,
                                                    name: selected.name
                                                });
                                            },
                                            children: "Select"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}
function CreateModeButton(props) {
    var ref = (0,react.useState)(function() {
        if (props.initialMode && props.initialAuxMode) {
            return {
                name: props.initialMode,
                collectionName: props.initialAuxMode,
                type: "collection"
            };
        } else if (props.initialMode) {
            var mode = CreateModes.find(function(mode) {
                return mode.name === props.initialMode;
            });
            return mode ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mode), {
                type: "mode"
            }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, CreateModes[0]), {
                type: "mode"
            });
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, CreateModes[0]), {
            type: "mode"
        });
    }), selected = ref[0], setSelected = ref[1];
    var ref1 = (0,react.useState)(false), showCollectionOptions = ref1[0], setShowCollectionOptions = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
        value: selected,
        disabled: props.disabled,
        onChange: function(value) {
            var ref;
            setSelected(value);
            (ref = props.onSetMode) === null || ref === void 0 ? void 0 : ref.call(props, value === null || value === void 0 ? void 0 : value.name);
        },
        children: function(param) {
            var open = param.open;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classNames("relative", (selected === null || selected === void 0 ? void 0 : selected.name) === "collection" ? "w-56" : "w-40"),
                    title: "Select a style",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
                            disabled: props.disabled,
                            onClick: function(e) {
                                setShowCollectionOptions(true);
                                e.stopPropagation();
                                e.preventDefault();
                            },
                            className: "dark:fill-gray-100 relative w-full cursor-default rounded-md hover:bg-gray-100 dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600 dark:ring-gray-600 dark:disabled:bg-gray-700 dark:disabled:text-gray-400 disabled:bg-gray-100 bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "h-4 w-4 flex-shrink-0",
                                            children: (selected === null || selected === void 0 ? void 0 : selected.type) === "collection" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RectangleStackIcon/* default */.Z, {}) : selected.image
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-3 block truncate",
                                            children: (selected === null || selected === void 0 ? void 0 : selected.type) === "collection" ? selected.collectionName : selected.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUpDownIcon/* default */.Z, {
                                        className: "h-5 w-5 dark:text-gray-400",
                                        "aria-hidden": "true"
                                    })
                                })
                            ]
                        }),
                        showCollectionOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionSelector, {
                            initialCollection: selected === null || selected === void 0 ? void 0 : selected.collectionName,
                            initialMode: selected === null || selected === void 0 ? void 0 : selected.name,
                            setSelected: function(collection) {
                                if (collection.type === "collection") {
                                    var ref;
                                    setSelected({
                                        name: "collection",
                                        type: "collection",
                                        collectionName: collection.name
                                    });
                                    (ref = props.onSetMode) === null || ref === void 0 ? void 0 : ref.call(props, "collection", collection.name);
                                } else {
                                    var ref1;
                                    setSelected({
                                        image: collection.image,
                                        name: collection.name,
                                        type: "mode"
                                    });
                                    (ref1 = props.onSetMode) === null || ref1 === void 0 ? void 0 : ref1.call(props, collection.name);
                                }
                            },
                            open: showCollectionOptions,
                            setOpen: setShowCollectionOptions
                        })
                    ]
                })
            });
        }
    });
}

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/sketch/SketchDialog.js




var DynamicSketch = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8056), __webpack_require__.e(251), __webpack_require__.e(5204)]).then(__webpack_require__.bind(__webpack_require__, 2860));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2860)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Loading..."
        });
    }
});
function SketchDialog(props) {
    var ref = (0,react.useState)(true), open = ref[0], setOpen = ref[1];
    (0,react.useEffect)(function() {
        if (!open) {
            var ref;
            props === null || props === void 0 ? void 0 : (ref = props.onClose) === null || ref === void 0 ? void 0 : ref.call(props);
        }
    }, [
        open,
        props,
        props.onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: open,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-10",
            onClose: setOpen,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-ggray-100 dark:bg-gray-950 text-left shadow-xl transition-all sm:p-8 sm:max-w-4xl flex flex-col items-center justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-gray-700 dark:text-gray-300 text-sm mb-3 my-3 sm:mt-0",
                                        children: "Draw a sketch to guide the AI"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSketch, {
                                        sketchState: props.sketchState,
                                        onSave: function(data) {
                                            var ref;
                                            props === null || props === void 0 ? void 0 : (ref = props.onSave) === null || ref === void 0 ? void 0 : ref.call(props, data);
                                            setOpen(false);
                                        }
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/PaintBrushIcon.js
var esm_PaintBrushIcon = __webpack_require__(6713);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/TrashIcon.js
var TrashIcon = __webpack_require__(8017);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js + 1 modules
var menu = __webpack_require__(471);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(7349);
// EXTERNAL MODULE: ./components/Spinner.js
var Spinner = __webpack_require__(6746);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/BoltIcon.js
var BoltIcon = __webpack_require__(4727);
;// CONCATENATED MODULE: ./components/CreateButton.js







function CreateButton_classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function CreateButton(props) {
    var fileInputRef = (0,react.useRef)(null);
    var hasMenu = !props.hideMenu;
    var handleFileSelect = function(e) {
        var ref;
        var file = (ref = e.target.files) === null || ref === void 0 ? void 0 : ref[0];
        ;
        if (file) {
            var reader = new FileReader();
            reader.onload = function(e) {
                var ref;
                (ref = props.onUpload) === null || ref === void 0 ? void 0 : ref.call(props, e.target.result);
            };
            reader.readAsArrayBuffer(file);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " inline-flex shadow-sm w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "file",
                ref: fileInputRef,
                onChange: handleFileSelect,
                accept: ".png,.jpg,.jpeg,.webp",
                className: "hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                disabled: props === null || props === void 0 ? void 0 : props.isCreating,
                onClick: function(e) {
                    props === null || props === void 0 ? void 0 : props.onCreate();
                    e.preventDefault();
                },
                className: CreateButton_classNames("inline-flex items-center bg-secondary-dark hover:bg-secondary-darkest disabled:bg-gray-500 w-full justify-center rounded-l-md border border-transparent px-3 lg:px-8 py-1 lg:py-2  text-base font-medium text-white shadow-sm  focus:outline-none sm:col-start-2", props.hideMenu ? "rounded-md" : "rounded-l-md"),
                children: [
                    (props === null || props === void 0 ? void 0 : props.isCreating) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sm:-ml-2 mr-1 flex-shrink w-6 h-6 pl-1 sm:pl-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {})
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BoltIcon/* default */.Z, {
                        className: "-ml-2 w-5 h-5 mr-1 sm:mr-2 pl-1 sm:pl-0"
                    }),
                    "Create"
                ]
            }),
            hasMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu */.v, {
                as: "div",
                className: "relative -ml-px block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu.Button */.v.Button, {
                        disabled: props === null || props === void 0 ? void 0 : props.isCreating,
                        className: "border disabled:bg-gray-500 disabled:border-l-gray-600 disabled:border-gray-500 border-secondary-dark hover:border-secondary-darkest border-l-secondary-darkest relative inline-flex items-center rounded-r-md bg-secondary-dark px-2 py-2 text-white hover:bg-secondary-darkest focus:z-10 disabled:text-gray-300",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Open options"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                className: "h-6 w-5",
                                "aria-hidden": "true"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        as: react.Fragment,
                        enter: "transition ease-out duration-100",
                        enterFrom: "transform opacity-0 scale-95",
                        enterTo: "transform opacity-100 scale-100",
                        leave: "transition ease-in duration-75",
                        leaveFrom: "transform opacity-100 scale-100",
                        leaveTo: "transform opacity-0 scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Items */.v.Items, {
                            className: "cursor-pointer absolute bottom-full right-0 z-10 -mr-1 my-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-0 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-700 dark:ring-gray-600 dark:text-gray-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "py-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                        children: function(param) {
                                            var active = param.active;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                                onClick: function() {
                                                    var ref;
                                                    return (ref = props.onCreate) === null || ref === void 0 ? void 0 : ref.call(props);
                                                },
                                                className: CreateButton_classNames(active ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-100" : "text-gray-700 dark:text-gray-100", "block px-4 py-2 text-sm"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoltIcon/* default */.Z, {
                                                                className: "w-4 h-4 mr-3"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "Create Single Image"
                                                        })
                                                    ]
                                                })
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                        children: function(param) {
                                            var active = param.active;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                                onClick: function() {
                                                    var ref;
                                                    return (ref = props.onBulkCreate) === null || ref === void 0 ? void 0 : ref.call(props);
                                                },
                                                className: CreateButton_classNames(active ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-100" : "text-gray-700 dark:text-gray-100", "block px-4 py-2 text-sm"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                viewBox: "0 0 20.001711 20.001542",
                                                                className: "w-4 h-3 mr-3",
                                                                x: "0px",
                                                                y: "0px",
                                                                fill: "currentColor",
                                                                version: "1.1",
                                                                width: "20.001711",
                                                                height: "20.001543",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                                    transform: "translate(3.4893159e-4,4.7922182e-4)",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                                        "data-name": "Layer 1",
                                                                        id: "g1",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "m 20,10.27 v 8.34 A 1.33,1.33 0 0 1 18.65,20 H 10.31 A 1,1 0 0 1 9.69,19.82 1.78,1.78 0 0 1 9.24,19.46 1.28,1.28 0 0 1 9,18.61 v -2.24 h 5.2 a 2.22,2.22 0 0 0 2.24,-2.24 V 8.92 h 2.24 A 1.33,1.33 0 0 1 20,10.27 Z M 9.64,15.52 h 4.49 a 1.32,1.32 0 0 0 1.34,-1.35 V 5.83 A 1.32,1.32 0 0 0 14.13,4.48 H 11.88 V 9.69 A 2.12,2.12 0 0 1 11.31,11.16 3.62,3.62 0 0 1 8.5,12 H 7.2 4.44 v 2.24 a 1.32,1.32 0 0 0 1.34,1.35 H 9.64 Z M 8.07,10.94 H 9.69 A 1.22,1.22 0 0 0 10.58,10.58 1.38,1.38 0 0 0 10.81,10.31 1.47,1.47 0 0 0 11,9.64 V 1.3 A 1.3,1.3 0 0 0 10.82,0.63 1.38,1.38 0 0 0 10.59,0.36 1.22,1.22 0 0 0 9.69,0 H 1.35 A 1.32,1.32 0 0 0 0,1.35 V 9.6 a 1.32,1.32 0 0 0 1.35,1.34 z"
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "Bulk Create"
                                                        })
                                                    ]
                                                })
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                        children: function(param) {
                                            var active = param.active;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                                onClick: function() {
                                                    var ref;
                                                    return (ref = props.onSketch) === null || ref === void 0 ? void 0 : ref.call(props);
                                                },
                                                className: CreateButton_classNames(active ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-100" : props.hasSketch ? " text-secondary  dark:text-secondary-light" : "text-gray-700 dark:text-gray-100", "block px-4 py-2 text-sm lg:hidden"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_PaintBrushIcon/* default */.Z, {
                                                                className: "w-4 h-3 mr-3"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "Sketch"
                                                        })
                                                    ]
                                                })
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                        children: function(param) {
                                            var active = param.active;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                onClick: function() {
                                                    return fileInputRef.current.click();
                                                },
                                                className: CreateButton_classNames(active ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-100" : props.hasUpload ? " text-secondary  dark:text-secondary-light" : "text-gray-700 dark:text-gray-100", "block px-4 py-2 text-sm lg:hidden"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaperClipIcon, {
                                                                className: "w-4 h-3 mr-3"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "Attach"
                                                        })
                                                    ]
                                                })
                                            });
                                        }
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/create/CreatePrompt.js








function PaperClipIcon(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: className,
        version: "1.1",
        viewBox: "-5 -13 75.000877 74.806664",
        fill: "currentColor",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "m 24.168,61.806566 c -7.7891,0 -15.113,-3.0352 -20.625,-8.5469 -5.5117,-5.5078 -8.543,-12.828 -8.543,-20.621 0,-7.7891 3.0312,-15.113 8.543,-20.625 L 24.75,-7.0413336 c 7.9531,-7.9688004 21.176,-7.9727004 29.301,0.15625 8.1211,8.1211 8.1211,21.3399996 0,29.4649996 l -21.207,19.051 c -2.1953,2.2031 -5.3359,3.5078 -8.6758,3.5078 -3.3398,0 -6.4766,-1.3008 -8.8398,-3.6602 -2.3594,-2.3594 -3.6602,-5.5 -3.6602,-8.8398 0,-3.3359 1.3008,-6.4766 3.6602,-8.8398 L 36.5314,4.7479164 c 1.707,-1.5352 4.3438,-1.4023 5.8867,0.31641 1.5391,1.7148 1.3945,4.3477 -0.31641,5.8866996 l -21.043,18.898 c -1.4648,1.4688 -1.4648,4.1133 0.16016,5.7383 1.5742,1.5781 4.3203,1.5781 5.8906,0 l 21.211,-19.051 c 4.707,-4.7188 4.707,-12.6519996 -0.16406,-17.52299957 -4.8789,-4.87110003 -12.809,-4.87890003 -17.68,0 L 9.27339,18.064326 c -3.7734,3.7812 -5.9375,9.0117 -5.9375,14.578 0,5.5625 2.168,10.797 6.1016,14.73 3.9336,3.933 9.168,6.1055 14.73,6.1055 5.5664,0 10.797,-2.168 14.73,-6.1055 l 24.133,-21.98 c 1.6992,-1.5508 4.332,-1.4258 5.8828,0.27344 1.5508,1.7031 1.4297,4.3359 -0.27734,5.8867 l -23.992,21.844 c -5.3633,5.375 -12.688,8.4102 -20.477,8.4102 z",
            id: "path2"
        })
    });
}
function SketchButton(param) {
    var sketchState = param.sketchState, setSketchOpen = param.setSketchOpen, setSketchState = param.setSketchState, setSketchBinaryData = param.setSketchBinaryData;
    return sketchState ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "isolate inline-flex rounded-md shadow-sm text-secondary dark:text-secondary-light",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: function(e) {
                    var ref;
                    setSketchOpen(true);
                    e.preventDefault();
                    (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Prompt - Sketch", {});
                },
                type: "button",
                className: "relative inline-flex items-center gap-x-1.5 rounded-l-md bg-white dark:bg-gray-700 dark:hover:bg-gray-600 dark:ring-gray-600 px-3 pr-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_PaintBrushIcon/* default */.Z, {
                        className: "-ml-0.5 h-4 w-4 text-secondary dark:text-secondary-light mr-1",
                        "aria-hidden": "true"
                    }),
                    "Sketch\xa0"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function(e) {
                    var ref;
                    setSketchState(null);
                    setSketchBinaryData(null);
                    e.preventDefault();
                    (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Prompt - Sketch - Delete", {});
                },
                type: "button",
                className: "relative -ml-px inline-flex items-center rounded-r-md bg-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-600 px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 focus:z-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrashIcon/* default */.Z, {
                    className: "w-4 h-4 dark:fill-secondary-light"
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        type: "button",
        className: "relative inline-flex items-center rounded-md bg-white dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600 dark:ring-gray-600 px-3 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-100 focus:z-10",
        onClick: function(e) {
            var ref;
            setSketchOpen(true);
            e.preventDefault();
            (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Prompt - Sketch - Open", {});
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_PaintBrushIcon/* default */.Z, {
                className: "-ml-0.5 w-4 h-4 mr-2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "Sketch"
            })
        ]
    });
}
function UploadButton(param) {
    var uploadState = param.uploadState, setUploadState = param.setUploadState, setUploadBinaryData = param.setUploadBinaryData;
    var fileInputRef = (0,react.useRef)(null);
    var handleFileSelect = function(e) {
        var ref;
        var file = (ref = e.target.files) === null || ref === void 0 ? void 0 : ref[0];
        if (file) {
            var reader = new FileReader();
            reader.onload = function(e) {
                setUploadBinaryData(e.target.result);
                setUploadState(true);
            };
            reader.readAsArrayBuffer(file);
        }
    };
    return uploadState ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "isolate inline-flex rounded-md shadow-sm text-secondary dark:text-secondary-light",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "file",
                ref: fileInputRef,
                onChange: handleFileSelect,
                accept: ".png,.jpg,.jpeg,.webp",
                className: "hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: function() {
                    var ref;
                    return (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
                },
                type: "button",
                className: "relative inline-flex items-center gap-x-1.5 rounded-l-md bg-white dark:bg-gray-700 dark:hover:bg-gray-600 dark:ring-gray-600 px-3 pr-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaperClipIcon, {
                        className: "-ml-0.5 h-4 w-4 text-secondary dark:text-secondary-light mr-1",
                        "aria-hidden": "true"
                    }),
                    "Attach\xa0"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function(e) {
                    var ref;
                    setUploadState(null);
                    setUploadBinaryData(null);
                    e.preventDefault();
                    (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Prompt - Upload - Delete", {});
                },
                type: "button",
                className: "relative -ml-px inline-flex items-center rounded-r-md bg-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-600 px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 focus:z-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrashIcon/* default */.Z, {
                    className: "w-4 h-4 dark:fill-secondary-light"
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "file",
                ref: fileInputRef,
                onChange: handleFileSelect,
                accept: ".png,.jpg,.jpeg,.webp",
                className: "hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "relative inline-flex items-center rounded-md bg-white dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600 dark:ring-gray-600 px-3 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-100 focus:z-10",
                onClick: function() {
                    var ref;
                    return (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaperClipIcon, {
                        className: "-ml-0.5 w-4 h-4 mr-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Attach"
                    })
                ]
            })
        ]
    });
}
function CreatePrompt(props) {
    var isCreating = props.isCreating, setPrompt = props.setPrompt, setSelectedMode = props.setSelectedMode, onCreate = props.onCreate, onBulkCreate = props.onBulkCreate, prompt = props.prompt, setSketchBinaryData = props.setSketchBinaryData, setUploadBinaryData = props.setUploadBinaryData, creditsRemaining = props.creditsRemaining, showPremium = props.showPremium, hideMisc = props.hideMisc, placeholder = props.placeholder, isSimple = props.isSimple;
    var ref = (0,react.useState)(false), sketchOpen = ref[0], setSketchOpen = ref[1];
    var ref1 = (0,react.useState)(false), sketchState = ref1[0], setSketchState = ref1[1];
    var ref2 = (0,react.useState)(false), uploadState = ref2[0], setUploadState = ref2[1];
    var ref3 = (0,react.useState)(false), showTooltip = ref3[0], setShowTooltip = ref3[1];
    var ref4 = (0,react.useState)("Private - Only you can see the created image"), tooltip = ref4[0], setTooltip = ref4[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: props.className || "flex space-x-4 items-center justify-center align-bottom sm:mx-32 md:mx-48 lg:mx-48 2xl:mx-96 mx-4 my-2 sm:my-8 mb-2 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white min-w-0 flex-1  dark:shadow-none dark:bg-gray-800 rounded-lg align-end self-end " + (props.className ? "shadow-none" : "shadow-xl shadow-slate-200"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    action: "#",
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "overflow-hidden rounded-lg border border-gray-300 dark:border-gray-700 shadow-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "comment",
                                    className: "sr-only",
                                    children: "Add"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                    autoFocus: true,
                                    onChange: function(e) {
                                        return setPrompt(e.target.value);
                                    },
                                    rows: 1,
                                    name: "comment",
                                    id: "comment",
                                    className: "block w-full resize-none border-0 p-6 mb-8 text-lg outline-none dark:bg-gray-800 dark:text-white",
                                    placeholder: placeholder || "What do you want to see?",
                                    defaultValue: prompt
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "py-2",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "py-px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-9"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "absolute inset-x-0 bottom-0 flex justify-between py-4 pl-2 mx-2 pr-2 lg:mx-4 sm:items-center sm:border-t border-t-gray-100 dark:border-t-gray-700 flex-col sm:flex-row",
                            children: [
                                isSimple ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1",
                                    children: " "
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateModeButton, {
                                            initialMode: props.initialMode,
                                            initialAuxMode: props.initialAuxMode,
                                            onSetMode: function(mode, auxMode) {
                                                return setSelectedMode(mode, auxMode);
                                            }
                                        }),
                                        !hideMisc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "ml-4 hidden lg:flex",
                                            title: "Attach a sketch to guide the AI",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SketchButton, {
                                                sketchState: sketchState,
                                                setSketchOpen: setSketchOpen,
                                                setSketchState: setSketchState,
                                                setSketchBinaryData: setSketchBinaryData
                                            })
                                        }),
                                        !hideMisc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "ml-4 hidden lg:flex",
                                            title: "Attach an image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadButton, {
                                                uploadState: uploadState,
                                                setUploadState: setUploadState,
                                                setUploadBinaryData: setUploadBinaryData
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative",
                                            onMouseEnter: function() {
                                                return setShowTooltip(true);
                                            },
                                            onMouseLeave: function() {
                                                return setShowTooltip(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 24 24",
                                                    fill: "currentColor",
                                                    className: "hidden sm:block w-5 h-5 fill-gray-500 ml-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
                                                    style: {
                                                        left: -100,
                                                        top: -40
                                                    },
                                                    className: "hidden md:block absolute pointer-events-none top-8",
                                                    show: showTooltip,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                                                        className: "whitespace-nowrap backdrop-blur-sm bg-black bg-opacity-70 text-white font-medium text-xs rounded-lg px-4 p-1",
                                                        enter: "transition-all ease-in-out duration-200",
                                                        enterFrom: "opacity-0",
                                                        enterTo: "opacity-100",
                                                        leave: "transition-all ease-in-out duration-200",
                                                        leaveFrom: "opacity-100",
                                                        leaveTo: "opacity-0",
                                                        children: tooltip
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (creditsRemaining || creditsRemaining === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "hidden sm:flex justify-end flex-1 text-right text-xs mr-4 hover:underline cursor-pointer " + (creditsRemaining <= 0 ? "text-red-600" : "text-gray-500"),
                                    onClick: function() {
                                        var ref;
                                        showPremium === null || showPremium === void 0 ? void 0 : showPremium();
                                        (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Prompt - Explicit Show premium", {});
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: creditsRemaining
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                "Credit",
                                                creditsRemaining === 1 ? "" : "s",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sm:inline hidden",
                                                    children: "left"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-shrink-0 flex items-center mt-2 sm:mt-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateButton, {
                                        isCreating: isCreating,
                                        hideMenu: isSimple,
                                        onCreate: onCreate,
                                        onBulkCreate: onBulkCreate,
                                        hasUpload: uploadState,
                                        hasSketch: sketchState,
                                        onUpload: function(data) {
                                            if (data) {
                                                setUploadBinaryData(data);
                                                setUploadState(true);
                                            }
                                        },
                                        onSketch: function() {
                                            return setSketchOpen(true);
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            sketchOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(SketchDialog, {
                sketchState: sketchState,
                onSave: function(data) {
                    setSketchBinaryData(data.buffer);
                    setSketchState(data.state);
                },
                onClose: function() {
                    return setSketchOpen(false);
                }
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/PlusIcon.js
var PlusIcon = __webpack_require__(7000);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/CheckCircleIcon.js
var CheckCircleIcon = __webpack_require__(5012);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/XCircleIcon.js
var XCircleIcon = __webpack_require__(256);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/CheckIcon.js
var CheckIcon = __webpack_require__(2536);
;// CONCATENATED MODULE: ./components/BulkCreateDialog.js
/* eslint-disable @next/next/no-html-link-for-pages */ 













var sleepPromise = function(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};
var createImage = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(prompt, mode, auxMode, i, total) {
        var ref, identifier, error, _$i, ref1, ref2, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    identifier = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                    error = null;
                    axios/* default.post */.Z.post("/api/image/create", {
                        prompt: prompt,
                        identifier: identifier,
                        mode: (ref = mode === null || mode === void 0 ? void 0 : mode.toLowerCase()) === null || ref === void 0 ? void 0 : ref.replace(/ /g, "-"),
                        auxMode: auxMode,
                        bulk: "".concat(i + 1, "/").concat(total)
                    }).catch(function(err) {
                        error = err;
                    });
                    return [
                        4,
                        sleepPromise(5000)
                    ];
                case 1:
                    _state.sent();
                    if (error) {
                        throw error;
                    }
                    _$i = 0;
                    _state.label = 2;
                case 2:
                    if (!(_$i < 120)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        axios/* default.post */.Z.post("/api/image/status", {
                            identifier: identifier
                        })
                    ];
                case 3:
                    result = _state.sent();
                    if ((result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.status) === "error") {
                        throw new Error("Error creating image");
                    }
                    if (result === null || result === void 0 ? void 0 : (ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.svg) {
                        return [
                            2,
                            result.data
                        ];
                    }
                    return [
                        4,
                        sleepPromise(2000)
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _$i++;
                    return [
                        3,
                        2
                    ];
                case 6:
                    throw new Error("Timeout");
            }
        });
    });
    return function createImage(prompt, mode, auxMode, i, total) {
        return _ref.apply(this, arguments);
    };
}();
var createAllImages = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(rows, notify) {
        var results, i, row, data, err, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    results = (0,_to_consumable_array/* default */.Z)(rows);
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < rows.length)) return [
                        3,
                        7
                    ];
                    row = rows[i];
                    row.status = "running";
                    notify === null || notify === void 0 ? void 0 : notify(results, i);
                    if (_.trim(row.prompt) === "") {
                        row.status = "skipped";
                        notify === null || notify === void 0 ? void 0 : notify(results, i);
                        return [
                            3,
                            6
                        ];
                    }
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        createImage(row.prompt, row.mode, row.auxMode, i, rows.length)
                    ];
                case 3:
                    data = _state.sent();
                    row.status = "done";
                    row.data = data;
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    row.status = "error";
                    row.error = err.message;
                    if ((err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                        throw err;
                    }
                    return [
                        3,
                        5
                    ];
                case 5:
                    notify === null || notify === void 0 ? void 0 : notify(results, i);
                    _state.label = 6;
                case 6:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 7:
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return function createAllImages(rows, notify) {
        return _ref.apply(this, arguments);
    };
}();
function RowStatus(props) {
    if (props.status === "done") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleIcon/* default */.Z, {
            className: "w-6 h-6 text-green-500 dark:text-green-400 mr-3"
        });
    } else if (props.status === "error") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(XCircleIcon/* default */.Z, {
            className: "w-6 h-6 text-red-500 dark:text-red-400 mr-3"
        });
    } else if (props.status === "running") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                className: "w-4 h-4 mr-3"
            })
        });
    } else if (props.status === "skipped") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(XCircleIcon/* default */.Z, {
            className: "w-6 h-6 text-gray-400 dark:text-gray-400 mr-3"
        });
    }
    return null;
}
function InputRow(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-col sm:flex-row sm:items-center fill-gray-900 dark:fill-gray-100 mt-2",
        children: [
            props.status && /*#__PURE__*/ (0,jsx_runtime.jsx)(RowStatus, {
                status: props.status
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-1 flex-col sm:flex-row sm:items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: props.id,
                        className: "block text-sm font-medium text-gray-700 dark:text-gray-100",
                        children: props.label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex-1 mr-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            autoFocus: true,
                            type: "text",
                            disabled: props.disabled,
                            defaultValue: props.prompt,
                            onChange: function(e) {
                                var ref;
                                return (ref = props.setPrompt) === null || ref === void 0 ? void 0 : ref.call(props, e.target.value);
                            },
                            className: "block w-full rounded-md px-3 p-1.5 shadow-sm focus:outline-none dark:disabled:text-gray-400 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-gray-400 sm:text-sm sm:leading-6 dark:bg-gray-700 dark:text-gray-100 dark:focus:ring-gray-500 dark:ring-gray-600"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 sm:mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateModeButton, {
                    position: props.position > 2 ? "bottom-full" : "top-full",
                    disabled: props.disabled,
                    initialMode: props.mode,
                    initialAuxMode: props.auxMode,
                    selectedMode: props.mode,
                    selectedAuxMode: props.auxMode,
                    onSetMode: function(mode, auxMode) {
                        var ref;
                        return (ref = props.setSelectedMode) === null || ref === void 0 ? void 0 : ref.call(props, mode, auxMode);
                    }
                })
            })
        ]
    });
}
function BulkCreateDialog(props) {
    var _initialPrompt;
    var initialRow = {
        prompt: (_initialPrompt = props.initialPrompt) !== null && _initialPrompt !== void 0 ? _initialPrompt : "",
        mode: props.initialMode,
        auxMode: props.initialAuxMode
    };
    var ref = (0,react.useState)(true), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)([
        initialRow
    ]), rows = ref1[0], setRows = ref1[1];
    var ref2 = (0,react.useState)(false), isCreating = ref2[0], setIsCreating = ref2[1];
    var ref3 = (0,react.useState)(false), isDone = ref3[0], setIsDone = ref3[1];
    var sendNotificationRef = (0,react.useRef)(true);
    var go = function() {
        var newRows = rows.map(function(row) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, row), {
                status: null
            });
        });
        ;
        setIsCreating(true);
        createAllImages(newRows, function(results, i) {
            ;
            setRows((0,_to_consumable_array/* default */.Z)(results));
        }).catch(function(err) {
            var ref;
            if ((err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                var ref1;
                (ref1 = props.setShowPurchase) === null || ref1 === void 0 ? void 0 : ref1.call(props, true);
            }
        }).then(function(results) {
            var ref;
            ;
            props === null || props === void 0 ? void 0 : (ref = props.onCreate) === null || ref === void 0 ? void 0 : ref.call(props, results);
            if (sendNotificationRef.current && (results === null || results === void 0 ? void 0 : results.filter(function(row) {
                return [
                    "done",
                    "error"
                ].includes(row.status);
            }).length) > 0) {
                ;
                return axios/* default.get */.Z.get("/api/image/bulk-done");
            }
        }).finally(function() {
            setIsDone(true);
        });
    };
    (0,react.useEffect)(function() {
        var unloadCallback = function(event) {
            if (isCreating) {
                event.preventDefault();
                event.returnValue = "Image creation will be stopped";
                return "Image creation will be stopped";
            }
        };
        window.addEventListener("beforeunload", unloadCallback);
        return function() {
            return window.removeEventListener("beforeunload", unloadCallback);
        };
    }, [
        isCreating
    ]);
    (0,react.useEffect)(function() {
        if (!open) {
            var ref;
            var lastDoneRow = rows.findLast(function(row) {
                return !!row.data;
            });
            props === null || props === void 0 ? void 0 : (ref = props.onClose) === null || ref === void 0 ? void 0 : ref.call(props, {
                isDone: isDone,
                data: lastDoneRow === null || lastDoneRow === void 0 ? void 0 : lastDoneRow.data
            });
        }
    }, [
        open,
        props,
        props.onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: open,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-10",
            onClose: function() {},
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 dark:bg-gray-950 dark:bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                                className: "w-full flex flex-col relative transform rounded-lg bg-ggray-100 dark:bg-gray-800 dark:text-gray-100 px-4 pt-2 pb-2 text-left shadow-xl transition-all sm:my-2 sm:w-full sm:max-w-4xl sm:p-6 min-h-[440px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center text-gray-900 dark:text-gray-100 my-2 font-medium text-lg",
                                        children: "Bulk Create"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center text-gray-500 dark:text-gray-400 text-sm px-2 sm:px-8 mt-2",
                                        children: "Define multiple prompts to create images in bulk"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex w-full flex-col justify-center mt-4 sm:mt-6 px-2 sm:px-8 flex-1",
                                                children: rows.map(function(row, i) {
                                                    return /*#__PURE__*/ (0,react.createElement)(InputRow, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, row), {
                                                        key: i,
                                                        position: i,
                                                        disabled: isCreating,
                                                        isCreating: isCreating,
                                                        deleteRow: function() {
                                                            setRows((0,_to_consumable_array/* default */.Z)(rows).splice(i, 1));
                                                        },
                                                        setPrompt: function(prompt) {
                                                            var newRows = (0,_to_consumable_array/* default */.Z)(rows);
                                                            newRows[i].prompt = prompt;
                                                            setRows(newRows);
                                                        },
                                                        setSelectedMode: function(mode, auxMode) {
                                                            var newRows = (0,_to_consumable_array/* default */.Z)(rows);
                                                            newRows[i].mode = mode;
                                                            newRows[i].auxMode = auxMode;
                                                            setRows(newRows);
                                                        }
                                                    }));
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: rows.length < 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "px-2 sm:px-8 mt-2 sm:mt-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        disabled: isCreating,
                                                        onClick: function() {
                                                            return setRows((0,_to_consumable_array/* default */.Z)(rows).concat([
                                                                (0,_object_spread/* default */.Z)({}, rows[rows.length - 1]) || initialRow
                                                            ]));
                                                        },
                                                        className: "flex text-gray-900 dark:text-gray-100 px-4 py-2 text-left text-sm hover:bg-gray-100 disabled:bg-gray-100 dark:disabled:bg-gray-700 items-center bg-white dark:bg-gray-700 dark:disabled:text-gray-400 rounded-md border dark:border-0 dark:hover:bg-gray-600 shadow-sm font-medium",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon/* default */.Z, {
                                                                className: "w-4 h-4 -ml-1 mr-2"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: "Add Prompt"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-left text-gray-700 dark:text-gray-100 text-sm px-2 sm:px-16 mt-4 sm:mt-6 font-medium justify-center items-center flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "Images are created one at a time. Keep your browser open until all images are created."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "inline-flex p-2 px-3 rounded border bg-white dark:bg-gray-700 dark:border-gray-600 items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            defaultChecked: true,
                                                            onChange: function(evt) {
                                                                sendNotificationRef.current = evt.target.checked;
                                                            },
                                                            type: "checkbox",
                                                            id: "notify-checkbox",
                                                            className: "mr-2"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "notify-checkbox",
                                                            children: "Send me an Email when done"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-4 sm:mt-8 flex justify-center items-center sm:-ml-28",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                className: "inline-flex justify-center px-4 py-2 text-base font-medium text-gray-700 bg-gray-100 dark:bg-gray-700 dark:text-gray-100 border border-transparent rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 mr-6",
                                                onClick: function() {
                                                    return setOpen(false);
                                                },
                                                children: "Cancel"
                                            }),
                                            isDone ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "inline-flex items-center bg-green-600 hover:bg-green-700 disabled:bg-gray-500 justify-center rounded-md border border-transparent px-5 py-1 lg:py-2 text-base font-medium text-white shadow-sm focus:outline-none sm:col-start-2",
                                                onClick: function(e) {
                                                    setOpen(false);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-shrink w-5 h-5 mr-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {})
                                                    }),
                                                    "Done"
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                disabled: isCreating,
                                                className: "inline-flex items-center bg-secondary-dark hover:bg-secondary-darkest disabled:bg-gray-500 justify-center rounded-md border border-transparent px-5 py-1 lg:py-2 text-base font-medium text-white shadow-sm focus:outline-none sm:col-start-2",
                                                onClick: function(e) {
                                                    go();
                                                },
                                                children: [
                                                    isCreating ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-shrink w-6 h-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {})
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        viewBox: "0 0 20.001711 20.001542",
                                                        className: "w-4 h-3 mr-2",
                                                        x: "0px",
                                                        y: "0px",
                                                        fill: "currentColor",
                                                        version: "1.1",
                                                        width: "20.001711",
                                                        height: "20.001543",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                            transform: "translate(3.4893159e-4,4.7922182e-4)",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                                "data-name": "Layer 1",
                                                                id: "g1",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "m 20,10.27 v 8.34 A 1.33,1.33 0 0 1 18.65,20 H 10.31 A 1,1 0 0 1 9.69,19.82 1.78,1.78 0 0 1 9.24,19.46 1.28,1.28 0 0 1 9,18.61 v -2.24 h 5.2 a 2.22,2.22 0 0 0 2.24,-2.24 V 8.92 h 2.24 A 1.33,1.33 0 0 1 20,10.27 Z M 9.64,15.52 h 4.49 a 1.32,1.32 0 0 0 1.34,-1.35 V 5.83 A 1.32,1.32 0 0 0 14.13,4.48 H 11.88 V 9.69 A 2.12,2.12 0 0 1 11.31,11.16 3.62,3.62 0 0 1 8.5,12 H 7.2 4.44 v 2.24 a 1.32,1.32 0 0 0 1.34,1.35 H 9.64 Z M 8.07,10.94 H 9.69 A 1.22,1.22 0 0 0 10.58,10.58 1.38,1.38 0 0 0 10.81,10.31 1.47,1.47 0 0 0 11,9.64 V 1.3 A 1.3,1.3 0 0 0 10.82,0.63 1.38,1.38 0 0 0 10.59,0.36 1.22,1.22 0 0 0 9.69,0 H 1.35 A 1.32,1.32 0 0 0 0,1.35 V 9.6 a 1.32,1.32 0 0 0 1.35,1.34 z"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    "Create"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./pages/create.js


















var prompts = [
    "A cute bear",
    "An astronaut walking on Mars",
    "Low poly bird",
    "Illustration of mountain landscape", 
];
function convertToPng(arrayBuffer) {
    return _convertToPng.apply(this, arguments);
}
function _convertToPng() {
    _convertToPng = (0,_async_to_generator/* default */.Z)(function(arrayBuffer) {
        var blob, img, canvas, ctx, url;
        return (0,tslib_es6.__generator)(this, function(_state) {
            blob = new Blob([
                arrayBuffer
            ]);
            img = new Image();
            canvas = document.createElement("canvas");
            ctx = canvas.getContext("2d");
            url = URL.createObjectURL(blob);
            // Return a promise that resolves with the PNG data URL
            return [
                2,
                new Promise(function(resolve, reject) {
                    img.onload = function() {
                        // Set canvas dimensions to fixed 1024x1024
                        canvas.width = 1024;
                        canvas.height = 1024;
                        // Calculate dimensions while preserving aspect ratio
                        var aspectRatio = img.width / img.height;
                        var newWidth, newHeight;
                        var offsetX = 0, offsetY = 0;
                        if (aspectRatio > 1) {
                            // Landscape
                            newWidth = canvas.width;
                            newHeight = canvas.width / aspectRatio;
                            offsetY = (canvas.height - newHeight) / 2;
                        } else {
                            // Portrait
                            newHeight = canvas.height;
                            newWidth = canvas.height * aspectRatio;
                            offsetX = (canvas.width - newWidth) / 2;
                        }
                        // Clear canvas and draw centered image
                        ctx.fillStyle = "white"; // Optional: fill background
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        ctx.drawImage(img, offsetX, offsetY, newWidth, newHeight);
                        // Convert to PNG data URL
                        var pngUrl = canvas.toDataURL("image/png");
                        // Clean up blob URL
                        URL.revokeObjectURL(url);
                        resolve(pngUrl);
                    };
                    img.onerror = function() {
                        URL.revokeObjectURL(url);
                        reject(new Error("Failed to load image"));
                    };
                    // Set image source to start loading
                    img.src = url;
                })
            ];
        });
    });
    return _convertToPng.apply(this, arguments);
}
function PremiumDialogActual(props) {
    // if (props.user?.id && props.user.id.slice(-1) > '8') {
    //     return <PremiumDialog2 {...props} />;
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumDialog/* default */.ZP, (0,_object_spread/* default */.Z)({}, props));
}
var __N_SSP = true;
function CreateLayout(props) {
    var user = props.user;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(props.initialMode ? props.initialMode : props.initialCollection ? "collection" : "simple"), selectedMode = ref[0], setSelectedMode = ref[1];
    var ref1 = (0,react.useState)(props.initialCollection), selectedAuxMode = ref1[0], setSelectedAuxMode = ref1[1];
    var ref2 = (0,react.useState)(props.initialUrl), svgUrl = ref2[0], setSvgUrl = ref2[1];
    var ref3 = (0,react.useState)(), identifier = ref3[0], setIdentifier = ref3[1];
    var ref4 = (0,react.useState)(false), isFallback = ref4[0], setIsFallback = ref4[1];
    var ref5 = (0,react.useState)(0), loadingTime = ref5[0], setLoadingTime = ref5[1];
    var ref6 = (0,react.useState)(), prompt = ref6[0], setPrompt = ref6[1];
    var ref7 = (0,react.useState)(false), isBoost = ref7[0], setIsBoost = ref7[1];
    var ref8 = (0,react.useState)(null), sketchData = ref8[0], setSketchData = ref8[1];
    var ref9 = (0,react.useState)(null), uploadData = ref9[0], setUploadData = ref9[1];
    var ref10 = (0,react.useState)(false), isCreating = ref10[0], setIsCreating = ref10[1];
    var ref11 = (0,react.useState)(null), status = ref11[0], setStatus = ref11[1];
    var ref12 = (0,react.useState)(""), error = ref12[0], setError = ref12[1];
    var ref13 = (0,react.useState)(null), creditsRemaining = ref13[0], setCreditsRemaining = ref13[1];
    var ref14 = (0,react.useState)(false), showPurchase = ref14[0], setShowPurchase = ref14[1];
    var ref15 = (0,react.useState)(false), showLogin = ref15[0], setShowLogin = ref15[1];
    var ref16 = (0,react.useState)(false), showBulk = ref16[0], setShowBulk = ref16[1];
    (0,react.useEffect)(function() {
        if (props.uploadData) {
            setUploadData(props.uploadData);
        }
    }, [
        props.uploadData
    ]);
    var poll = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(identifier, pollingTime) {
            var ref, ref1, result, ref2, ref3, ref4, ref5, ref6;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/image/status", {
                                identifier: identifier
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.status) {
                            ;
                            setStatus(result.data.status);
                            setIsFallback(result.data.fallback || result.data.genFallback);
                            if (result.data.status === "error") {
                                ;
                                setError(result.data.nsfw ? "NSFW content detected. Please adjust your prompt and try again." : "Something went wrong. Try again...");
                                setIsCreating(false);
                                (ref2 = window.umami) === null || ref2 === void 0 ? void 0 : ref2.track("Create Error", {
                                    time: pollingTime,
                                    error: result.data
                                });
                                return [
                                    2
                                ];
                            }
                        } else if (pollingTime > 120) {
                            ;
                            setError("Something went wrong. Try again...");
                            setIsCreating(false);
                            (ref3 = window.umami) === null || ref3 === void 0 ? void 0 : ref3.track("Create Error", {
                                time: pollingTime
                            });
                            return [
                                2
                            ];
                        } else {
                            setTimeout(function() {
                                poll(identifier, pollingTime);
                            }, 2000);
                            return [
                                2
                            ];
                        }
                        setLoadingTime(pollingTime);
                        setIdentifier(identifier);
                        if (result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.svg) {
                            ;
                            setIsCreating(false);
                            setSvgUrl((result === null || result === void 0 ? void 0 : (ref4 = result.data) === null || ref4 === void 0 ? void 0 : ref4.fallback) ? "https://my.vectorart.ai/storage/v1/object/public/vectorart-upload/".concat(result.data.svg) : "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/".concat(result.data.svg, "/sm"));
                            (ref5 = window.umami) === null || ref5 === void 0 ? void 0 : ref5.track("Create Done", {
                                svg: result.data.svg,
                                prompt: prompt,
                                time: pollingTime
                            });
                            (ref6 = props.onSelectItem) === null || ref6 === void 0 ? void 0 : ref6.call(props, result.data);
                        } else {
                            setTimeout(function() {
                                var ref;
                                poll(identifier, [
                                    "active",
                                    "queued_1"
                                ].includes(result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.status) ? (pollingTime || 0) + 1 : pollingTime || 0);
                            }, 2000);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function poll(identifier, pollingTime) {
            return _ref.apply(this, arguments);
        };
    }();
    var go = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, inError, pngData, dataStrength, png, identifier;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!prompt && !uploadData || isCreating) {
                            return [
                                2
                            ];
                        }
                        setIsCreating(true);
                        setError(null);
                        setIdentifier(null);
                        setLoadingTime(0);
                        setSvgUrl(null);
                        inError = false;
                        pngData = null;
                        dataStrength = undefined;
                        if (!uploadData) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            convertToPng(uploadData).catch(function(err) {
                                var ref;
                                (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Upload PNG Error", {
                                    prompt: prompt,
                                    selectedMode: selectedMode,
                                    err: err
                                });
                            })
                        ];
                    case 1:
                        png = _state.sent();
                        pngData = png;
                        dataStrength = prompt ? 0.3 : 0.5;
                        _state.label = 2;
                    case 2:
                        identifier = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                        axios/* default.post */.Z.post("/api/image/create", {
                            prompt: prompt || "vectorize this image",
                            identifier: identifier,
                            boost: isBoost,
                            mode: (ref = selectedMode === null || selectedMode === void 0 ? void 0 : selectedMode.toLowerCase()) === null || ref === void 0 ? void 0 : ref.replace(/ /g, "-"),
                            auxMode: selectedAuxMode,
                            sketchData: pngData || sketchData,
                            strength: dataStrength
                        }).then(function(result) {
                            var ref;
                            setCreditsRemaining(result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.credits);
                        }).catch(function(err) {
                            var ref, ref1, ref2, ref3;
                            inError = true;
                            setIsCreating(false);
                            if ((err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                                var ref4;
                                setShowPurchase(true);
                                (ref4 = window.umami) === null || ref4 === void 0 ? void 0 : ref4.track("Create Show Purchase", {
                                    prompt: prompt,
                                    selectedMode: selectedMode
                                });
                            } else if ((err === null || err === void 0 ? void 0 : (ref1 = err.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 400) {
                                var ref5;
                                (ref5 = window.umami) === null || ref5 === void 0 ? void 0 : ref5.track("Create No Auth", {
                                    prompt: prompt,
                                    selectedMode: selectedMode
                                });
                                setShowLogin(true);
                            } else if ((err === null || err === void 0 ? void 0 : (ref2 = err.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 422) {
                                var ref6;
                                (ref6 = window.umami) === null || ref6 === void 0 ? void 0 : ref6.track("Create Error", {
                                    prompt: prompt,
                                    selectedMode: selectedMode,
                                    err: err
                                });
                                setError("Too many simultaneous requests. Wait for some to finish and try again...");
                            } else if ((err === null || err === void 0 ? void 0 : (ref3 = err.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 413) {
                                var ref7;
                                (ref7 = window.umami) === null || ref7 === void 0 ? void 0 : ref7.track("Create Error File Too Large", {
                                    prompt: prompt,
                                    selectedMode: selectedMode,
                                    err: err
                                });
                                setError("File too large. Try a different image...");
                            } else {
                                var ref8;
                                (ref8 = window.umami) === null || ref8 === void 0 ? void 0 : ref8.track("Create Error", {
                                    prompt: prompt,
                                    selectedMode: selectedMode,
                                    err: err
                                });
                                setError("Something went wrong. Try again...");
                            }
                        });
                        // console.log(result);
                        setTimeout(function() {
                            if (!inError) {
                                poll(identifier);
                            }
                        }, 5000);
                        (ref1 = window.umami) === null || ref1 === void 0 ? void 0 : ref1.track("Create Image", {
                            prompt: prompt,
                            selectedMode: selectedMode,
                            selectedAuxMode: selectedAuxMode
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function go() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (props.skipRandomPrompt) {
            return;
        }
        setPrompt(props.initialPrompt || prompts[Math.max(0, Math.min(prompts.length - 1, Math.round(Math.random() * prompts.length)))]);
    }, []);
    // {/* <div className="w-full bg-red-700 text-center text-white text-sm p-4">VectorArt is experiencing increased errors due to an upstream service outage</div> */}
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateResult, {
                svgUrl: svgUrl,
                isCreating: isCreating,
                error: error,
                status: status,
                identifier: identifier,
                loadingTime: loadingTime,
                isFallback: isFallback,
                initialComponent: props.initialComponent,
                isMinimal: props.isExternal,
                uploadData: uploadData,
                dropzone: props.dropzone,
                previewView: props.previewView,
                onSelectItem: props.onSelectItem,
                showDownloadPng: props.showDownloadPng,
                showPrint: props.showPrint
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePrompt, {
                initialMode: selectedMode,
                initialAuxMode: selectedAuxMode,
                isCreating: isCreating,
                setPrompt: setPrompt,
                prompt: prompt,
                setSelectedMode: function(mode, auxMode) {
                    var ref;
                    setSelectedMode(mode);
                    setSelectedAuxMode(auxMode);
                    (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Prompt - Mode", {
                        mode: mode
                    });
                },
                onCreate: function() {
                    return go();
                },
                onBulkCreate: function() {
                    var ref;
                    setShowBulk(true);
                    (ref = window.umami) === null || ref === void 0 ? void 0 : ref.track("Create Prompt - Bulk create", {});
                },
                isBoost: isBoost,
                setIsBoost: setIsBoost,
                setSketchBinaryData: setSketchData,
                setUploadBinaryData: setUploadData,
                showPremium: function() {
                    return setShowPurchase(true);
                },
                creditsRemaining: creditsRemaining,
                hideMisc: !!selectedAuxMode || props.isExternal,
                isSimple: props.isSimple,
                placeholder: props.placeholder
            }),
            showLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Auth/* AuthDialog */.o, {
                open: showLogin,
                setOpen: setShowLogin,
                supabase: auth/* supabase */.O,
                url: router.asPath,
                title: "Sign up to continue creating for free"
            }) : null,
            showPurchase ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumDialogActual, {
                user: user || props.user,
                onClose: function() {
                    return setShowPurchase(false);
                }
            }) : showBulk && /*#__PURE__*/ (0,jsx_runtime.jsx)(BulkCreateDialog, {
                user: user || props.user,
                initialPrompt: prompt,
                initialMode: selectedMode,
                initialAuxMode: selectedAuxMode,
                setShowPurchase: setShowPurchase,
                onClose: function(param) {
                    var isDone = param.isDone, data = param.data;
                    setShowBulk(false);
                    ;
                    if (isDone && data.svg) {
                        setSvgUrl((data === null || data === void 0 ? void 0 : data.fallback) ? "https://my.vectorart.ai/storage/v1/object/public/vectorart-upload/".concat(data.svg) : "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/".concat(data.svg, "/sm"));
                    }
                }
            })
        ]
    });
}
function CreatePage(props) {
    var user = (0,react.useContext)(UserContext/* default */.Z).user;
    if (!user && !props.user) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full h-screen flex flex-col dark:bg-gray-950",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative border-b border-gray-100 dark:border-gray-900",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            className: "secondary"
                        }, props), {
                            supabase: auth/* supabase */.O,
                            user: user,
                            showCreate: false,
                            title: "Create",
                            description: "Create vector graphics with AI"
                        }))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex space-x-4 mt-6 mx-4 sm:mx-32 md:mx-48 lg:mx-64 xl:mx-96 items-center justify-center pt-16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Auth/* default */.Z, {
                            supabase: auth/* supabase */.O,
                            redirectTo: "/create",
                            onSignedIn: function(user) {
                                ;
                                window.location.reload();
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-32",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full h-screen flex flex-col bg-gray-100 dark:bg-gray-950",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative border-b border-gray-200 dark:border-gray-800 bg-white z-10 dark:bg-gray-900",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: "secondary "
                    }, props), {
                        supabase: auth/* supabase */.O,
                        user: user,
                        showCreate: false,
                        description: "Create vector graphics with AI"
                    }))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateLayout, (0,_object_spread/* default */.Z)({
                user: user
            }, props))
        ]
    });
}


/***/ })

}]);